import { useAction, useAtom } from "@reatom/npm-react";
import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RoutesPaths } from "src/routes/RoutesPaths";
import { selectedProductAtom, productSelectionStore } from "src/store/atoms";

import { useInfinityScroll } from "../../hooks/useInfinityScroll";
import { useProductPageTranslate } from "../../hooks/useProductPageTranslate";
import { ProductTableData } from "../../store/fetchers";
import { searchProductStore } from "../../store/fetchers";
import { updateProductSelectionWithDebounceRequest } from "../../widgets/ProductSamples/store/fetchers/updateProductSelectionRequest";
import { ProductPagination } from "../Pagination";
import { ProductCards } from "../ProductCards/ProductCards";
import { ProductsTable } from "../ProductsTable";
import css from "./ProductData.module.scss";

interface ProductDataProps {
  isTable?: boolean;
}
export const ProductData = ({ isTable }: ProductDataProps) => {
  const navigate = useNavigate();

  const {
    products,
    isLoading,
    isFetchLoading,
    isRefreshing,
    hasNext,
    onLoadMore,
  } = useInfinityScroll();

  const updateProducts = useAction(searchProductStore.updateProducts);

  useEffect(() => {
    if (products.length === 0) {
      updateProducts();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTable]);

  const { refreshingData } = useProductPageTranslate();

  const [selectedIds] = useAtom(productSelectionStore.selectedIdsAtom);
  const [productSample, setProductSample] = useAtom(
    productSelectionStore.currentSelectionAtom,
  );
  const setSelectedIds = useAction(productSelectionStore.setSelectedIdsAction);
  const updateSelection = useAction(updateProductSelectionWithDebounceRequest);

  const setSelectProduct = useAction(selectedProductAtom);

  const handleOnSelectProduct = useCallback(
    (product: ProductTableData) => {
      setSelectProduct(product.id);
      navigate(RoutesPaths.LK.PRODUCT(product.id));
    },
    [navigate, setSelectProduct],
  );

  const handleSelectionChange = useCallback(
    async (newSelectedIds: number[]) => {
      setSelectedIds(newSelectedIds);

      if (productSample) {
        const res = await updateSelection(productSample.id, {
          productIds: newSelectedIds,
        }).catch((error) => {
          console.error("Ошибка при обновлении выборки:", error);
          return null;
        });

        if (res) {
          setProductSample(res);
        }
      }
    },
    [setSelectedIds, productSample, updateSelection],
  );

  return (
    <div className={css.productDataContainer}>
      {isTable ? (
        <>
          <div className={css.tableContainer}>
            {(isRefreshing || isFetchLoading) && (
              <div className={css.refreshingOverlay}>
                <div className={css.refreshingSpinner}>
                  <div className={css.spinner}></div>
                  <span>{refreshingData}</span>
                </div>
              </div>
            )}
            <ProductsTable
              products={products}
              productSample={productSample}
              onRowClick={handleOnSelectProduct}
              isLoading={isLoading}
              selectedIds={selectedIds}
              setSelectedIds={handleSelectionChange}
            />
          </div>
          <ProductPagination isTable={true} />
        </>
      ) : (
        <ProductCards
          isLoading={isLoading}
          products={products}
          onLoadMore={onLoadMore}
          onClick={handleOnSelectProduct}
          isFetchLoading={isFetchLoading}
          hasNext={hasNext}
        />
      )}
    </div>
  );
};
